import React, { useState, FC, PropsWithChildren } from 'react';
import { useBreakpoints } from 'common/hooks';
import { useIsomorphicLayoutEffect } from 'fronton-react';

export enum MediaGalleryType {
  Mobile = 'mobile',
  Desktop = 'desktop',
}

type Props = PropsWithChildren & { bot: boolean; currentDevice: string; type: MediaGalleryType };

export const AdaptiveMediaGalleryContainer: FC<Props> = ({ bot, currentDevice, type, children }) => {
  const { smMobile, mobile, tablet, desktop, largeDesktop } = useBreakpoints() || {
    smMobile: false,
    mobile: false,
    tablet: false,
    desktop: false,
    largeDesktop: false,
  };

  const isMobileSsr =
    type === MediaGalleryType.Mobile && (currentDevice === 'tablet' || currentDevice === 'mobile');
  const isDesktopSsr = type === MediaGalleryType.Desktop && currentDevice === 'desktop';

  const isMobile = type === MediaGalleryType.Mobile && (smMobile || mobile || tablet);
  const isDesktop = type === MediaGalleryType.Desktop && (desktop || largeDesktop);

  const [isVisible, setIsVisible] = useState(isMobileSsr || isDesktopSsr);

  useIsomorphicLayoutEffect(() => {
    setIsVisible(isMobile || isDesktop);
  }, [isMobile, isDesktop]);

  if (bot || isVisible) {
    return <>{children}</>;
  }
};
